"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var urls_1 = __importDefault(require("../../app/urls"));
var components_1 = require("../../youwell-common/components");
var components_2 = require("../../common/components");
var SingleTaskPage_1 = __importDefault(require("./SingleTaskPage"));
var taskContentUtils_1 = require("../../common/taskContentUtils");
var Index = /** @class */ (function (_super) {
    __extends(Index, _super);
    function Index() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getLinkUrl = function (link) {
            var _a = (0, taskContentUtils_1.parseInternalLink)(link), taskOrModuleId = _a.taskOrModuleId, hash = _a.hash;
            return "".concat(urls_1.default.singlepage, "/").concat(taskOrModuleId).concat(hash);
        };
        return _this;
    }
    Index.prototype.render = function () {
        return (React.createElement(components_2.Layout, { hideHeaderLinks: true, hideMenu: true },
            React.createElement(components_2.InternalLinkLoader, { linkUrlFunction: this.getLinkUrl }),
            React.createElement(react_router_dom_1.Switch, null,
                React.createElement(react_router_dom_1.Route, { path: "".concat(urls_1.default.singlepage, "/:taskId"), component: SingleTaskPage_1.default }),
                React.createElement(react_router_dom_1.Route, { component: components_1.PageNotFound }))));
    };
    return Index;
}(React.Component));
exports.default = Index;
